import { useCallback, useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { ThemeGroupSelectContext } from '../contexts';
import styles from './Select.module.css';

type Props = {
  onClick: () => void;
};

/**
 * "Create Theme" button at the bottom of the theme dropdown
 * Triggers the palette creation callback
 */
export const CreateThemeButton = ({ onClick }: Props) => {
  const select = useContext(ThemeGroupSelectContext);

  if (!select) {
    throw new Error('CreateThemeButton must be used within ThemeGroupSelectContext');
  }

  const handleClick = useCallback(() => {
    onClick();
    select!.close();
  }, [
    onClick,
    select,
  ]);

  return (
    <MenuItem
      classes={{ root: styles.create }}
      disableRipple
      onClick={handleClick}>
      <div className={styles.item}>
        <div className={styles.text}>+ Create Theme</div>
      </div>
    </MenuItem>
  );
};

CreateThemeButton.displayName = 'ChartTheming.CreateThemeButton';
